import { Asset } from '@thehubz/client/data-access-api';

export const DefaultAssetType = [
  {
    _id: Asset.AssetTypeEnum.Image,
    name: $localize`Image`,
  },
  {
    _id: Asset.AssetTypeEnum.Pdf,
    name: $localize`PDF`,
  },
  {
    _id: Asset.AssetTypeEnum.Video,
    name: $localize`Video`,
  },
  {
    _id: Asset.AssetTypeEnum.Audio,
    name: $localize`Audio`,
  },
  {
    _id: Asset.AssetTypeEnum.HtmlBanner,
    name: $localize`HTML Banner`,
  },
  {
    _id: Asset.AssetTypeEnum.PowerpointPresentation,
    name: $localize`Powerpoint presentation`,
  },
  {
    _id: Asset.AssetTypeEnum.Zip,
    name: $localize`ZIP`,
  },
  {
    _id: Asset.AssetTypeEnum.Other,
    name: $localize`Other`,
  },
];
